// extracted by mini-css-extract-plugin
module.exports = {"image":"Image__image"};
    if(module.hot) {
      // 1790535708950
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  